import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';

function getStyle(pinWidth, reversed, backgroundColor) {
  const PIN_Y_SHIFT = -22;
  const PIN_X_SHIFT = 8;
  const REVERSED_PIN_X_SHIFT = -pinWidth - 3;
  const PIN_BORDER_RADIUS = 3;
  const PIN_TRIANGLE_WIDTH = 15;
  const PIN_TRIANGLE_HEIGHT = 5;
  const PIN_CONTAINER_TRANSFORMS = [
    { translateX: reversed ? REVERSED_PIN_X_SHIFT : PIN_X_SHIFT },
    { translateY: PIN_Y_SHIFT },
  ];
  const PIN_TRIANGLE_TRANSFORMS = [
    { scaleX: reversed ? -1 : 1 },
    { translateX: reversed ? -pinWidth + 15 : 0 },
    { translateY: -1 },
  ];
  return StyleSheet.create({
    container: {
      transform: PIN_CONTAINER_TRANSFORMS,
    },
    pin: {
      justifyContent: 'center',
      alignItems: 'center',
      padding: 3,
      backgroundColor,
      borderTopLeftRadius: PIN_BORDER_RADIUS,
      borderTopRightRadius: PIN_BORDER_RADIUS,
      borderBottomRightRadius: !reversed ? PIN_BORDER_RADIUS : 0,
      borderBottomLeftRadius: reversed ? PIN_BORDER_RADIUS : 0,
    },
    triangleCorner: {
      width: 0,
      height: 0,
      backgroundColor: 'transparent',
      borderStyle: 'solid',
      borderRightWidth: PIN_TRIANGLE_WIDTH,
      borderTopWidth: PIN_TRIANGLE_HEIGHT,
      borderRightColor: 'transparent',
      borderTopColor: backgroundColor,
      transform: PIN_TRIANGLE_TRANSFORMS,
    },
    text: {
      textAlign: 'center',
      fontSize: 13,
      fontWeight: '600',
      color: 'white',
      backgroundColor: 'transparent',
    },
  });
}

class ChartPin extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 30 };
    this.onLayout = this.onLayout.bind(this);
  }

  onLayout(event) {
    const { width, height } = event.nativeEvent.layout;
    this.setState({ width, height });
  }

  render() {
    const { style, reversed, color, text } = this.props;
    const styles = getStyle(this.state.width, reversed, color);
    return (
      <View style={[style, styles.container]}>
        <View style={[styles.pin]} onLayout={this.onLayout}>
          <Text style={styles.text}>{text}</Text>
        </View>
        <View style={[styles.triangleCorner]} />
      </View>
    );
  }
}

ChartPin.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  reversed: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
};

export default ChartPin;
